import { alternarOffcanvas } from "./utilidades/alternarOffcanvas";
import { listen as quicklinkListen } from "quicklink/dist/quicklink.mjs";
import { inicializarInternacionalizacao } from './localizacao/global/global';
import { onAuthBroadcast } from './utilidades/authBroadcast';
import { cookieConsent } from './componentes/cookieConsent';
import { registrarServiceWorker } from './pwa/registrarServiceWorker';


const headerFooter = {
    alterarAbaHeader(abaSelecionada) {

        abaSelecionada = abaSelecionada.split('-')[0];
        if (abaSelecionada === 'vaga') {
            abaSelecionada = 'vagas';
        }

        for (const aba of document.getElementsByClassName('aba-logado')) {
            aba.classList.toggle('aba-logado-ativo', aba.classList.contains(abaSelecionada))
        }

        for (const abaMobile of document.getElementsByClassName('nav-mobile-item')) {
            abaMobile.classList.toggle('ativo', abaMobile.classList.contains(abaSelecionada))
        }
    },
    trocarFlecha: {
        _trocar(elemento) {

        },
        dropdown(dropdown) {
            dropdown.addEventListener('show.bs.dropdown', () => this._trocar(dropdown));
            dropdown.addEventListener('hide.bs.dropdown', () => this._trocar(dropdown));
        },
        collapse(botaoCollapse) {
            const alvo = document.getElementById(botaoCollapse.getAttribute('aria-controls'));
            alvo.addEventListener('show.bs.collapse', () => this._trocar(botaoCollapse));
            alvo.addEventListener('hide.bs.collapse', () => this._trocar(botaoCollapse));
        },
    },
    alterarTabAtiva(aba) {
        aba.forEach((abaMenu) => {
            const sideBar = abaMenu.closest(".side-bar-candidato");

            if(sideBar){
                const navLinks = sideBar.querySelectorAll(".nav-link");

                navLinks.forEach((link) => {
                    link.classList.remove("link-menu-ativo");
                });

                abaMenu.classList.add("link-menu-ativo");
                const menuCollapse = abaMenu.closest('.collapse-interno');

                if(menuCollapse){
                    menuCollapse.classList.add('show');
                }

                let icone = abaMenu.querySelector(".bi");
                if (icone) {
                    icone.classList.forEach(classe => {
                        if (classe.startsWith("bi-") && !classe.endsWith("-fill") && (classe != "bi-bullseye" && classe != "bi-search")) {
                            icone.classList.replace(classe, classe + "-fill");
                        }
                    });
                }
            }

            else{
                for (const item of abaMenu.parentElement.children) {

                    if(item.classList.contains("aba-logado") || item.classList.contains("nav-mobile-item"))
                        continue;
                    
                    item.classList.remove("link-menu-ativo");

                    // Reseta o �cone para a vers�o normal (sem "-fill")
                    let icone = item.querySelector(".bi");
                    if (icone) {
                        icone.classList.forEach(classe => {
                            if (classe.startsWith("bi-") && classe.endsWith("-fill")) {
                                icone.classList.replace(classe, classe.replace("-fill", ""));
                            }
                        });
                    }
                }

                if (
                    !abaMenu.classList.contains("aba-logado") &&
                    !abaMenu.classList.contains("nav-mobile-item")

                ) {
                    abaMenu.classList.add("link-menu-ativo");

                    // Troca o �cone da aba ativa para a vers�o com o "fill"
                    let iconeAtivo = abaMenu.querySelector(".bi");
                    if (iconeAtivo) {
                        iconeAtivo.classList.forEach(classe => {
                            if (classe.startsWith("bi-") && !classe.endsWith("-fill")) {
                                iconeAtivo.classList.replace(classe, classe + "-fill");
                            }
                        });
                    }
                }
            }
        });
    },
    async menuLogado() {
        if (document.contains(document.querySelector("#header-empresa"))) {
            return;
        }
        const headerLogado = document.getElementById('header-candidato-logado');

        if (!document.contains(headerLogado)) {
            return;
        }

        const hotsiteTipoElement = document.getElementById('hotsiteTipo');
        const hotsiteTipo = hotsiteTipoElement == null ? '' : hotsiteTipoElement.value;

        const { getGeoData } = await import('./utilidades/geoData');
        const { carregarUsuarioLogado } = await import('./utilidades/usuarioLogado');

        await carregarUsuarioLogado();

        const tagsBuscaEspecificaContainer = document.getElementById('tags-busca-especifica');
        if (tagsBuscaEspecificaContainer != null && (hotsiteTipo == '' || hotsiteTipo == 'Express')) {
            const geoData = getGeoData();

            // guarda contra geo lixo ja persistida (cidade/uf vazias quando os headers cf-* faltaram):
            // sem cidade E sem uf nao ha chip para montar — o container fica oculto
            if (geoData.existe && (geoData.data.cidade || geoData.data.regiaoCodigo)) {
                const i18next = await import('i18next');
                const classButton = hotsiteTipo == 'Express' ? 'btn-secondary' : 'btn-outline-primary';

                tagsBuscaEspecificaContainer.innerHTML = '';

                if (geoData.data.cidade) {
                    const linkCidade = document.createElement('a');
                    linkCidade.href = `/${CULTURE_EMPREGARE}/vagas?query=&localidade=${encodeURIComponent(geoData.data.cidade)}`;
                    linkCidade.className = `btn ${classButton} btn-sm`;
                    linkCidade.textContent = `${i18next.t('GeolocalizacaoVagasEm')} ${geoData.data.cidade}`;
                    tagsBuscaEspecificaContainer.appendChild(linkCidade);
                }

                if (geoData.data.regiaoCodigo) {
                    const linkEstado = document.createElement('a');
                    linkEstado.href = `/${CULTURE_EMPREGARE}/vagas?query=&localidade=${encodeURIComponent(geoData.data.regiaoCodigo.toLowerCase())}`;
                    linkEstado.className = `btn ${classButton} btn-sm`;
                    linkEstado.textContent = `${i18next.t('GeolocalizacaoVagasEstado')} ${geoData.data.regiaoCodigo}`;
                    tagsBuscaEspecificaContainer.appendChild(linkEstado);
                }

                tagsBuscaEspecificaContainer.classList.remove('d-none');
            }
        }

        let abaAtual = window.location.pathname.split("/").pop(); // obterQueryString().tab;

        // Regra para ativar busca de vagas na tela de detalhes da vaga e da Employer Page

        if(abaAtual.includes("trabalhe-na") || abaAtual.includes("vaga-"))
            abaAtual = "vagas";
        else if (abaAtual.includes("inscricao_"))
            abaAtual = "candidaturas";

        if (abaAtual) {
            try {
                this.alterarTabAtiva(document.querySelectorAll(`.${CSS.escape(abaAtual)}`));
            } catch (e) { }
        }
    },
    async init() {
        inicializarInternacionalizacao();
        cookieConsent.init();
        registrarServiceWorker(); // nao-bloqueante: agenda o registro do SW no evento 'load'

        const sessaoExpirada = function () {
            var modal = document.getElementById('modal-sessao-expirada');
            if (!modal) { window.location.reload(); return; }
            var instancia = bootstrap.Modal.getInstance(modal) || new bootstrap.Modal(modal);
            if (modal.classList.contains('show')) return;
            instancia.show();
        };

        const _fetch = window.fetch;
        window.fetch = function (...args) {
            if (args[0] && typeof args[0] !== 'function') {
                args[1] = args[1] || {};
                args[1].headers = Object.assign({ 'X-Requested-With': 'XMLHttpRequest' }, args[1].headers);
            }
            return _fetch.apply(this, args).then(function (response) {
                if (response.status === 401) sessaoExpirada();
                return response;
            });
        };

        onAuthBroadcast((evento) => {
            if (evento === 'logout') sessaoExpirada();
            else if (evento === 'login') window.location.reload();
        });

        const { autocompleteBuscaRecenteCargo, autocompleteBuscaRecenteLocalizacao } = await import('./utilidades/eventoBuscarVagaRedirect');

        quicklinkListen({
            ignores: [
                (uri, elem) => !elem.hasAttribute('prefetch') //Os links que possuiram tal atributo irão dar prefetch
            ]
        });

        const selectCultures = document.querySelectorAll('.cultura');
        const culturaSelecionada = document.getElementsByClassName('cultura-selecionada');

        for (const botaoCultura of culturaSelecionada) {
            botaoCultura.innerHTML = document.querySelector(`a.cultura[data-culture="${CULTURE_EMPREGARE}"]`).innerHTML
        }

        selectCultures.forEach(selectCulture =>
            selectCulture.onclick = e =>
            document.querySelectorAll('.cultura-selecionada').forEach(dropdown => {
                let culture = e.target.getAttribute('data-culture');

                if (!culture)
                    culture = e.currentTarget.getAttribute('data-culture');

                // A URL pode trazer a cultura em OUTRA caixa (ex.: "/pt-BR/") enquanto CULTURE_EMPREGARE
                // vem canonico em minusculo ("pt-br"). String.replace com string e sensivel a caixa e NAO
                // trocaria o idioma nesse caso (regressao da migracao .NET 10: o CultureFilter deixou de
                // fazer o 302 que normalizava pt-BR->pt-br). Trocamos SO o 1o segmento do path, de forma
                // INSENSIVEL A CAIXA, para o idioma trocar independente de como a cultura veio na URL.
                const urlAtual = new URL(window.location.href);
                urlAtual.pathname = urlAtual.pathname.replace(
                    new RegExp('^/' + CULTURE_EMPREGARE + '(?=/|$)', 'i'), '/' + culture);
                window.location.href = urlAtual.toString();
            })
        );

        await this.menuLogado();

        this.alterarAbaHeader(window.location.pathname.split('/').pop());
        alternarOffcanvas(document.getElementById('menu-lateral-logado'));

        const formHeaderBuscarVagas = document.getElementsByClassName('formHeaderBuscarVagas');

        for (const form of formHeaderBuscarVagas) {
            if (document.contains(form)) {
                //this.autocomplete(form, "#" + form.getAttribute('data-autocompleteId'));
                //this.autocompleteBuscasRecentes(form, 'input[name="cargo"]');
                // Campo desligado pela empresa sai como hidden (Vagas/IndexHotSite): o wrapper do autocomplete viraria
                // um item flex vazio na barra de busca.
                const seletorLocal = "#" + form.getAttribute('data-autocompleteId');
                if (form.querySelector(seletorLocal)?.type !== 'hidden')
                    autocompleteBuscaRecenteLocalizacao(form, seletorLocal);
                if (form.querySelector('input[name="cargo"]')?.type !== 'hidden')
                    autocompleteBuscaRecenteCargo(form, 'input[name="cargo"]');
            }            
        }

        const formHomeBuscarVaga = document.getElementById('formHomeBuscarVaga');

        if (document.contains(formHomeBuscarVaga)) {
            //headerFooter.autocomplete(formHomeBuscarVaga, '#localizacao-home');            
            //this.autocompleteBuscasRecentes(formHomeBuscarVaga, 'input[name="cargo"]');
            autocompleteBuscaRecenteLocalizacao(formHomeBuscarVaga, '#localizacao-home');
            autocompleteBuscaRecenteCargo(formHomeBuscarVaga, 'input[name="cargo"]');
        }

        const { login } = await import('./login');
        login();
    }
}

headerFooter.init();
